import axios from "axios";
import common from "./index.js";
import router from "../router/index.js";
// import store from '../store/index.js'
// 创建axios实例

const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.NODE_ENV === "development" ? "/devapi" : "",
  // 超时
  timeout: 30000
});
// 白名单
const whiteList = [
  "/confirm",
  "/login",
  "/finish",
  "/wxLogin",
  "/authorize",
  "/wxBind",
  "/invoice",
  "/viewer",
  "/loginApply",
  "/apply",
  "/apply/registered",
  "/Audit",
  "/remind",
  "/down",
  "/pay",
  "/comPay",
  "/ePay",
  "/yxwarn",
  "/cancelPay",
  "/mdreport",
  "/h5order",
  "/wxInvokeScan"
];
/** 请求拦截 */
service.interceptors.request.use(
  config => {
    if (localStorage.getItem("Authorization")) {
      config.headers["Authorization"] = localStorage.getItem("Authorization");
    } else {
      if (whiteList.indexOf(router.currentRoute.path) === -1) {
        common.returnWXAuthorization();
      }
    }
    return config;
  },
  error => {
    return Promise.error(error);
  }
);
/** 响应拦截 */
service.interceptors.response.use(
  response => {
    if (response.data && response.data.code === 401) {
      localStorage.removeItem("Authorization");
      common.returnWXAuthorization();
    }
    if (response.code && response.data.code === 3) {
      common.returnWXAuthorization();
    }
    return response;
  },
  error => {
    if (error.response) {
      // 失败响应的status需要在response中获得
      // console.log(error.response)
      switch (error.response.status) {
        case 401:
          // alert('token过期')
          common.returnWXAuthorization();
          // router.replace({name: 'login'})
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/common/request.js